import React from "react";
import ConfirmationModalWrapper from "app/components/ConfirmationModalWrapper";

interface Props {
  componentName: string | undefined;
  onSubmit(): void;
  onClose(): void;
  loading: boolean;
}

const GroupDeleteModal: React.FC<Props> = ({
  componentName,
  onSubmit,
  onClose,
  loading,
}) => {
  return (
    <ConfirmationModalWrapper
      title="Delete group"
      onClose={onClose}
      onSave={onSubmit}
      loading={loading}
      submitText="Delete"
      cancelText="Cancel"
    >
      <div className="text-sm font-medium text-secondary p-6">
        Are you sure that you want to delete {componentName} group? The tickets
        which are included to the group will be moved to No titles group.
      </div>
    </ConfirmationModalWrapper>
  );
};

export default GroupDeleteModal;
